import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SecurePaymentBadge } from './SecurePaymentBadge';
import { PRICE } from '../data/content';
const bullets = ['Guía emocional práctica de 7 días', 'Incluye 3 bonos exclusivos', 'Acceso inmediato desde cualquier dispositivo'];
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 22
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ivory" data-id="element-126" data-mp="xanqw5cpdri0">
      <div aria-hidden="true" className="pointer-events-none absolute -right-40 top-[-10rem] h-[34rem] w-[34rem] rounded-full bg-shell blur-3xl" data-id="element-127" data-mp="x8b6zmndx72b" />
      <div className="relative mx-auto grid max-w-6xl items-center gap-14 px-6 pb-20 pt-14 md:grid-cols-[1.05fr_0.95fr] md:gap-16 md:pb-28 md:pt-20 lg:px-8" data-id="element-128" data-mp="nczqozwbvrsg">
        <motion.div initial="hidden" animate="show" transition={{
        staggerChildren: 0.12,
        delayChildren: 0.1
      }} data-id="element-129" data-mp="3cz5vmcnsk20v">
          <motion.p variants={fadeUp} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="font-sans text-[0.62rem] uppercase tracking-luxe text-gold" data-id="element-130" data-mp="3j896f9neq5ny">
            Punto de Acción · Kit Digital de Reinicio Emocional
          </motion.p>

          <motion.h1 variants={fadeUp} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-6 font-display text-[2.6rem] font-light leading-[1.05] text-ink sm:text-6xl lg:text-[4.2rem]" data-id="element-131" data-mp="3e95zfjnv9pdc">
            La mujer que
            <br data-id="element-132" data-mp="35a2gqgsm3bzd" />
            <span className="italic text-gold" data-id="element-133" data-mp="35aklk1tcayiw">olvidaste</span> ser
            <span className="align-super font-sans text-[0.7rem] tracking-normal text-warmgray" data-id="element-134" data-mp="2ql6e4z9bqr65">
              ™
            </span>
          </motion.h1>

          <motion.p variants={fadeUp} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-7 max-w-reading font-sans text-[1.02rem] font-light leading-relaxed text-warmgray" data-id="element-135" data-mp="2hjf6vpz4yca6">
            7 días para volver a ti y recuperar la mujer que el estrés, las heridas y las
            responsabilidades hicieron desaparecer.
          </motion.p>

          <motion.p variants={fadeUp} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-5 max-w-reading border-l border-beige pl-5 font-display text-xl font-light italic leading-relaxed text-ink" data-id="element-136" data-mp="n9i7fmmg3wyv">
            No necesitas empezar una nueva vida. Necesitas volver a encontrarte contigo.
          </motion.p>

          <motion.ul variants={fadeUp} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-9 space-y-3.5" data-id="element-137" data-mp="16344cokqtoaw">
            {bullets.map(item => <li key={item} className="flex items-start gap-3" data-id="element-138" data-mp="x1w80c1sexjg">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-goldsoft" data-id="element-139" data-mp="x3h6gcr830ml">
                  <CheckIcon className="h-3 w-3 text-gold" data-id="element-140" data-mp="3hqtynzb83nvw" />
                </span>
                <span className="font-sans text-[0.95rem] font-light text-ink" data-id="element-141" data-mp="1x9kugm9v74h7">{item}</span>
              </li>)}
          </motion.ul>

          <motion.div variants={fadeUp} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-11 flex flex-col items-start gap-6 sm:flex-row sm:items-center" data-id="element-142" data-mp="21bxy9551wsbc">
            <CTAButton location="hero" data-id="element-143" data-mp="2b1hjuik5f09w">Quiero volver a mí</CTAButton>
            <div data-id="element-144" data-mp="2g0c0bdun8cqu">
              <p className="font-display text-3xl font-light text-ink" data-id="element-145" data-mp="2fyr5dn4f2rsg">
                Hoy: <span className="text-gold" data-id="element-146" data-mp="2kyndnyk5d5dt">{PRICE}</span>
              </p>
              <p className="mt-1 font-sans text-[0.68rem] uppercase tracking-[0.16em] text-mute" data-id="element-147" data-mp="2l0qc96zd86u5">
                Pago único · Acceso inmediato · Garantía de 7 días
              </p>
            </div>
          </motion.div>

          <motion.div variants={fadeUp} transition={{
          duration: 0.9,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-7" data-id="element-148" data-mp="umpsm8yqnz26">
            <SecurePaymentBadge data-id="element-149" data-mp="zm2mverxw8es" />
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="relative" data-id="element-150" data-mp="4aclrbd6jn6w">
          <div className="absolute inset-x-6 bottom-4 top-6 rounded-[2rem] bg-sand/70" aria-hidden="true" data-id="element-151" data-mp="9ah4z95h2w0t" />
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/36cc61f7-6141-4a79-9703-8eb483583f2d.jpg" alt="Mockup del kit digital La mujer que olvidaste ser, mostrado en libro impreso y tablet" className="relative w-full rounded-[2rem] object-cover shadow-[0_40px_90px_-50px_rgba(58,51,46,0.55)]" loading="eager" data-id="element-152" data-mp="3hq0txvz41sa2" />
        </motion.div>
      </div>
    </header>;
}